export default function NoPage() {
    return (
        <h1>No Page Found</h1>
    )
}